import React, {Component} from 'react'
import {Footer} from '@sabre/spark-react'
import 'sabre-spark/dist/css/spark.light.css'


class SignInTemplate extends Component {
    render() {
        return (
            <div className="spark-content--sticky-footer">
                <div className="spark-content__wrapper--sticky-footer">
                    <article
                        className="spark-splash-screen spark-splash-screen--panel spark-splash-screen--sign-in spark-main--sticky-footer">
                        <section className="spark-splash-screen__content">
                            <div className="spark-panel spark-splash-screen__center col-xs-12 col-md-8 col-lg-6">
                                <div className="spark-panel__content">
                                    {this.props.children}
                                </div>
                            </div>
                        </section>
                    </article>
                    <Footer/>
                </div>
            </div>
        )
    }
}

export default SignInTemplate






// WEBPACK FOOTER //
// ./src/shared/components/SignInTemplate.js